import React from "react";
import { CandlestickIcon, TrendlineIcon, ChartGridIcon } from "../icons/TradingIcons";

export default function TradingBackground({ variant = "candlestick" }) {
    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute inset-0 opacity-[0.03] dark:opacity-[0.05]">
                {variant === "candlestick" && (
                    <div className="grid grid-cols-8 gap-8 p-8">
                        {Array.from({ length: 32 }).map((_, i) => (
                            <div key={i} className="text-slate-900 dark:text-white">
                                <CandlestickIcon
                                    className="w-full h-12"
                                    bullish={Math.random() > 0.5}
                                />
                            </div>
                        ))}
                    </div>
                )}
                {variant === "trendline" && (
                    <div className="grid grid-cols-6 gap-12 p-8">
                        {Array.from({ length: 24 }).map((_, i) => (
                            <div key={i} className="text-slate-900 dark:text-white">
                                <TrendlineIcon
                                    className="w-full h-16"
                                    direction={i % 2 === 0 ? "up" : "down"}
                                />
                            </div>
                        ))}
                    </div>
                )}
                {variant === "grid" && (
                    <div className="grid grid-cols-5 gap-10 p-8">
                        {Array.from({ length: 20 }).map((_, i) => (
                            <div key={i} className="text-slate-900 dark:text-white">
                                <ChartGridIcon className="w-full h-16" />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
